import React, { Component } from 'react';

// Mapa de calor día × hora, compartido por Ventas y por Salón (ENI-260).
//
// A mano y no con una librería: un heatmap día×hora es una grilla, y tanto recharts como chart.js
// obligan a falsearlo (scatter / plugin matrix) por más peso y peor resultado.
//
// EL VALOR VA ADENTRO DE LA CELDA, no sólo en el `title`. La versión anterior confiaba en el
// tooltip nativo del navegador, que tarda medio segundo en aparecer y no se descubre solo: el
// color decía "acá pasa algo" y no había forma rápida de saber cuánto. Con el número adentro, el
// mapa se lee de un vistazo y el hover queda para el detalle completo.
//
// El texto se pinta blanco sobre las celdas intensas y oscuro sobre las claras: con un color fijo
// hay un tramo del degradé donde el número no se lee, y una celda ilegible es peor que una vacía.

const DIAS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

// Formato compacto: en una celda de ~34 px no entra "$1.234.567". Se pierde precisión a
// propósito — el número exacto está en el hover.
function compacto(v) {
    if (v == null) return '';
    const n = Number(v);
    if (n === 0) return '';
    if (Math.abs(n) >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
    if (Math.abs(n) >= 1000) return `${Math.round(n / 1000)}k`;
    if (Math.abs(n) >= 10) return String(Math.round(n));
    return n.toFixed(1);
}

class HeatmapComponent extends Component {
    render() {
        const {
            cells,               // [{ weekday, hour, value, detail }]
            emptyText = 'Sin datos en el período.',
            color = '0, 123, 255',
            // Cómo se rotula el valor adentro de la celda. Por defecto, compacto.
            formatCell = compacto,
            // Filas a ocultar cuando no tienen ningún dato (p. ej. días que el local no abrió).
            hideEmptyRows = false,
        } = this.props;

        if (!cells || cells.length === 0) return <p className="text-muted mb-0">{emptyText}</p>;

        const porCelda = new Map(cells.map((c) => [`${c.weekday}-${c.hour}`, c]));
        const horas = [...new Set(cells.map((c) => c.hour))].sort((a, b) => a - b);
        const max = Math.max(...cells.map((c) => Number(c.value) || 0), 0);

        const filas = DIAS.map((dia, idx) => ({ dia, idx }))
            .filter(({ idx }) => !hideEmptyRows || horas.some((h) => {
                const c = porCelda.get(`${idx}-${h}`);
                return c && Number(c.value) > 0;
            }));

        return (
            <div style={{ overflowX: 'auto' }}>
                <table className="table table-sm mb-0" style={{ tableLayout: 'fixed' }}>
                    <thead>
                        <tr>
                            <th style={{ width: 46 }} />
                            {horas.map((h) => (
                                <th key={h} className="text-center p-1" style={{ fontSize: 11, fontWeight: 400 }}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filas.map(({ dia, idx }) => (
                            <tr key={dia}>
                                <td className="p-1" style={{ fontSize: 11 }}>{dia}</td>
                                {horas.map((h) => {
                                    const celda = porCelda.get(`${idx}-${h}`);
                                    const valor = celda ? Number(celda.value) || 0 : 0;
                                    const intensidad = max > 0 ? valor / max : 0;
                                    // A partir de acá el fondo es lo bastante oscuro como para que
                                    // el texto negro deje de leerse.
                                    const oscura = intensidad > 0.55;
                                    return (
                                        <td
                                            key={h}
                                            className="p-1 text-center"
                                            title={celda && celda.detail ? celda.detail : `${DIAS[idx]} ${h}:00 — sin datos`}
                                            style={{
                                                backgroundColor: valor > 0 ? `rgba(${color}, ${0.12 + intensidad * 0.78})` : 'transparent',
                                                height: 30,
                                                fontSize: 10,
                                                color: oscura ? '#fff' : '#495057',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {formatCell(valor)}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default HeatmapComponent;
